/**
 * Returns the Display_Name for an account or investment account.
 * Uses nickname when non-empty, otherwise falls back to name or fund_name.
 */
export function getDisplayName(
  entity: { name?: string; fund_name?: string; nickname?: string | null }
): string {
  if (entity.nickname != null && entity.nickname !== "") {
    return entity.nickname;
  }
  return entity.name ?? entity.fund_name ?? "";
}

/**
 * Given a list of items already mapped to { id, displayName, account_number },
 * returns a new list where any duplicate displayName has the account_number
 * (or id when account_number is null) appended in parentheses.
 * Items with unique displayNames are returned unchanged.
 */
export function disambiguateDisplayNames<
  T extends { id: string; displayName: string; account_number: string | null }
>(items: T[]): T[] {
  // Count occurrences of each displayName
  const counts = new Map<string, number>();
  for (const item of items) {
    counts.set(item.displayName, (counts.get(item.displayName) ?? 0) + 1);
  }

  return items.map((item) => {
    if ((counts.get(item.displayName) ?? 0) > 1) {
      const suffix = item.account_number ?? item.id;
      return { ...item, displayName: `${item.displayName} (${suffix})` };
    }
    return item;
  });
}
